import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ContentTabModel } from 'src/app/models/content-tab';

@Component({
    selector: 'app-content-tab-list',
    templateUrl: './content-tab-list.component.html',
    styleUrls: ['./content-tab-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentTabListComponent implements OnInit {

  @Input() tabs: Array<ContentTabModel> = [];
  @Input() activeTabId: string|number = 0;

  @Output() onTabClick: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onTabClicked(event: ContentTabModel): void {
    this.activeTabId = event.id;
    this.onTabClick.emit(event.data);
  }

}
